module.exports = __webpack_public_path__ + "img/new-logo.f482ee2c.png";